import { Metamodel } from 'app/model/base/model';
import { FormatReadSettings } from './format-read-settings';
import { BinaryDataset } from 'app/model/dataset/binary.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.binary.formatRead,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(BinaryDataset) }
})
export class BinaryFormatReadSettings extends FormatReadSettings {}
